export default {
  path: '/rfid',
  component: () => import('@/views/rfid/index.vue'),
  children: [
    {
      path: '',
      name: 'RFID',
      component: () => import('@/views/rfid/pages/rfid.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'developer',
          'support',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'accounting_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ]
      }
    }
  ]
}
